<template>

	<div class="d-flex flex-row align-items-top flex-wrap image-list">

		<image-panel v-for='image in images'
			:value="image"
			:max-height="maxSize"
			:max-width="maxSize"
			:key="image.thumbUrl"
			icon="fa-image"
			:image-url="image.thumbUrl"
			:expand-url="image.fullUrl"
			:expand-on-click="true"
			:readonly="readonly"
			:show-user="showUser"
			v-on:open="open(image)"
			v-on:rotate="rotate($event,image)"
			v-on:deleteImg="deleteImg(image)">
		</image-panel>

		<slot></slot>

	</div>

</template>
<script type="text/javascript">
import ImagePanel from "./ImagePanel"

export default {
	name: "ImageThumbList",
	components: {
		ImagePanel
	},
	props: [
		/**
		* 'images' property expects an object of images with url property : {
		*	thumbUrl: (the url string),
		*	fullUrl: (the url string)
		* }
		**/
		"images",
		"maxSize",
		"readonly",
		"showUser"
	],
	data() {
		return {
			showViewer: false,
			url: ""
		}
	},
	methods: {
		rotate(direction,image) {
			this.$emit("rotate",direction,image)
		},
		deleteImg(image) {
			this.$emit("deleteImg",image)
		},
		open(image) {
			this.url = image.fullUrl
			this.showViewer = true
			
		}
	}
}
</script>